import { render, staticRenderFns } from "./AnswerBox.vue?vue&type=template&id=09615b6f&"
import script from "./AnswerBox.vue?vue&type=script&lang=js&"
export * from "./AnswerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports